import api from '../config/axiosConfig';

export const RepresentanteService = {
  verificarExistencia: async ({ token, numero, tipoDocumento }) => {
    if (!numero || !tipoDocumento) {
      throw new Error("Número y tipo de documento son requeridos");
    }

    try {
      const response = await api.get(`/clientes/representantes/verificar?numero=${numero}&tipoDocumento=${tipoDocumento}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data || { existe: false, representantes: [] };
    } catch (error) {
      console.error("Error en RepresentanteService.verificarExistencia:", error);
      throw error;
    }
  },
};
